import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Fires a "sign-out" event to the native bridge when the user taps the
// sign-out element. The click is allowed to proceed normally so Turbo
// submits the DELETE request server-side; the native side concurrently
// clears cookies and resets all tab navigators.
export default class extends BridgeComponent {
  static component = "sign-out"

  connect() {
    super.connect()
    this.element.addEventListener("click", this.handleClick)
  }

  disconnect() {
    super.disconnect()
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick = () => {
    this.send("sign-out")
  }
}
